import React from 'react';
import PropTypes from 'prop-types';
import {
  Row, Form, Input, Select, Button, Collapse, Col,
} from 'antd';
import { round } from '../../../utils/MathUtils';

const ImportShapefilesThirdStage = (props): JSX.Element => {
  const {
    land,
    matriculation,
    culturesOptions,
    fileShapes,
    clickedShape,
    handleFileShapesForm,
    handleClickedShapeCollapse,
  } = props;

  return (
    <div className="first-col third-stage">
      <Collapse
        defaultActiveKey={[clickedShape.key]}
        activeKey={clickedShape.key}
        accordion
        onChange={
          (eventt): void => {
            handleClickedShapeCollapse('collapsible', eventt);
          }
        }
      >
        {
          fileShapes.sort((a, b) => a.key - b.key).map((shape, index) => {
            if (!shape.isDeleted) {
              const { form, key, area } = shape;

              return (
                <Collapse.Panel
                  header={`Talhão ${key}`}
                  extra={`Área total: ${round(area, 2)} hectares`}
                  key={key}
                >
                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <span className="green-span">BP: </span>
                      <span>{matriculation.value}</span>
                    </Col>
                  </Row>
                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <span className="green-span">Propriedade: </span>
                      <span>{land.value}</span>
                    </Col>
                  </Row>
                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <Form.Item
                        style={{ marginBottom: 'unset' }}
                        label="Nome"
                        labelCol={{ span: 24 }}
                        required
                        validateStatus={form.name.error ? 'error' : ''}
                        help={form.name.error || false}
                      >
                        <Input
                          placeholder="Digite o nome"
                          value={form.name.value || undefined}
                          onChange={
                            (eventt): void => {
                              handleFileShapesForm(
                                index, 'name', eventt.target.value,
                              );
                            }
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <Form.Item
                        style={{ marginBottom: 'unset' }}
                        label="Cultura"
                        labelCol={{ span: 24 }}
                        required
                        validateStatus={form.culture.error ? 'error' : ''}
                        help={form.culture.error || false}
                      >
                        <Select
                          showSearch
                          placeholder="Selecione a cultura"
                          value={form.culture.value || undefined}
                          onChange={
                            (value): void => {
                              handleFileShapesForm(
                                index, 'culture', value,
                              );
                            }
                          }
                        >
                          {
                            culturesOptions.map((element) => (
                              <Select.Option
                                key={`${element.id}${element.description}`}
                                value={`::${element.id}::${element.description}`}
                              >
                                {element.description}
                              </Select.Option>
                            ))
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row gutter={[24, 24]}>
                    <Col span={24}>
                      <Form.Item
                        style={{ marginBottom: 'unset' }}
                        label="Outras informações"
                        labelCol={{ span: 24 }}
                      >
                        <Input.TextArea
                          placeholder="Digite outras informações"
                          value={form.details.value || undefined}
                          onChange={
                            (eventt): void => {
                              handleFileShapesForm(
                                index, 'details', eventt.target.value,
                              );
                            }
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <div className="buttons-form">
                        <Button
                          type="primary"
                          className="button-grey"
                          onClick={
                            (): void => {
                              handleClickedShapeCollapse(
                                'nextOrPrevious', key, false,
                              );
                            }
                          }
                        >
                          Voltar
                        </Button>
                        <Button
                          type="primary"
                          className="button-save"
                          onClick={
                            (): void => {
                              handleClickedShapeCollapse(
                                'nextOrPrevious', key, true,
                              );
                            }
                          }
                        >
                          Próximo
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Collapse.Panel>
              );
            }
            return null;
          })
        }
      </Collapse>
    </div>
  );
};

ImportShapefilesThirdStage.propTypes = {
  matriculation: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,

  land: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,

  culturesOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
  fileShapes: PropTypes.arrayOf(PropTypes.any).isRequired,
  clickedShape: PropTypes.shape().isRequired,
  handleFileShapesForm: PropTypes.func.isRequired,
  handleClickedShapeCollapse: PropTypes.func.isRequired,
};

ImportShapefilesThirdStage.defaultProps = {};

export default ImportShapefilesThirdStage;
